<div class="app-main">
  <app-header></app-header>
  <div
    class="app-main__container"
    id="app-main__container"
  >
    <app-aside></app-aside>
    <div
      [class.main-content--collapsed]="isAsideCollapsed"
      class="main-content"
    >
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
